import { useContext } from 'react';
import { SearchContext } from '../SearchContext';

export function useSearchContext() {
	const context = useContext(SearchContext);

	return context;
}
